import { DateTime } from 'luxon'
import {
  getElapsedSecondsFromMidnight,
  hoursFromSeconds,
  minutesFromSeconds,
} from '@utils/time'
import { Time } from '../types'

export const convertFromClockToElapsedTimeSinceMidnight = (
  hour: number | null,
  minute: number | null,
  dateEditing: DateTime,
  timeZone: string,
  { assumeMidnightIsEndOfDay } = { assumeMidnightIsEndOfDay: false },
): Time => {
  if (hour === null || isNaN(hour)) return { hour: null, minute: null }
  if (minute === null || isNaN(minute)) return { hour: null, minute: null }

  const elapsed = getElapsedSecondsFromMidnight(
    hour,
    minute,
    dateEditing,
    timeZone,
    { assumeMidnightIsEndOfDay },
  )

  const elapsedHour = hoursFromSeconds(elapsed)
  const elapsedMinute = minutesFromSeconds(elapsed)

  return { hour: elapsedHour, minute: elapsedMinute }
}
